import AbstractJobApplyForm from "./job_apply_forms";

class StepResumeInfo extends AbstractJobApplyForm {

  constructor(currentStepFormId) {
    super(currentStepFormId);

    this.initPage();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.$customFields !== 'undefined' && document.getElementById('job-apply-form-step-resume-info')) {
    new StepResumeInfo('job-apply-form-step-resume-info');
  }
});
